function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevonDown = function SvgChevonDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "chevon_down_svg2__a",
    x1: -13.671,
    x2: 183.499,
    y1: 189.938,
    y2: 78.488,
    gradientTransform: "matrix(1 0 0 -1 0 200)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3d43c1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#a80096"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100 154.55c-2.32 0-4.65-.89-6.43-2.66L2.66 60.97c-3.55-3.55-3.55-9.3 0-12.85s9.3-3.55 12.85 0l84.48 84.48 84.48-84.48c3.55-3.55 9.3-3.55 12.85 0s3.55 9.3 0 12.85l-90.91 90.91a9.07 9.07 0 0 1-6.43 2.66z",
    style: {
      fill: "url(#chevon_down_svg2__a)"
    }
  }));
};
export default SvgChevonDown;